import { render } from "./SortTableFiltersComponent.vue?vue&type=template&id=1dddb07e&scoped=true"
import script from "./SortTableFiltersComponent.vue?vue&type=script&lang=js"
export * from "./SortTableFiltersComponent.vue?vue&type=script&lang=js"

import "./SortTableFiltersComponent.vue?vue&type=style&index=0&id=1dddb07e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dddb07e"]])

export default __exports__